export default __webpack_public_path__ + "static/media/svg-6.3a1c7154.svg";